"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenOcean = void 0;
const web3_candies_1 = require("@defi.org/web3-candies");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const lodash_1 = __importDefault(require("lodash"));
var OpenOcean;
(function (OpenOcean) {
    const URL = "https://open-api.openocean.finance/v3";
    const chainNames = {
        [web3_candies_1.networks.eth.id]: "eth",
        [web3_candies_1.networks.bsc.id]: "bsc",
        [web3_candies_1.networks.arb.id]: "arbitrum",
        [web3_candies_1.networks.poly.id]: "polygon",
        [web3_candies_1.networks.ftm.id]: "fantom",
        [web3_candies_1.networks.avax.id]: "avax",
        [web3_candies_1.networks.linea.id]: "linea",
        [web3_candies_1.networks.zksync.id]: "zksync",
        [web3_candies_1.networks.base.id]: "base",
        [web3_candies_1.networks.glmr.id]: "moonbeam",
        [web3_candies_1.networks.oeth.id]: "op",
    };
    function findRoute(chainId, src, dst, amountIn, exchangeAdapter = web3_candies_1.zeroAddress, onlyDex, partner) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${URL}/${chainNames[chainId]}/swap_quote?${new URLSearchParams({
                chain: chainNames[chainId],
                inTokenAddress: src.address,
                outTokenAddress: dst.address,
                amount: (0, bignumber_js_1.default)(amountIn)
                    .div(Math.pow(10, src.decimals))
                    .toString(),
                slippage: "5",
                gasPrice: "5",
                account: exchangeAdapter,
                enabledDexIds: onlyDex || "",
                referrer: partner || "",
                connectors: "", //0xf4c8e32eadec4bfe97e0f595add0f4450a863a11,0x52f24a5e03aee338da5fd9df68d2b6fae1178827,0x90c97f71e18723b0cf0dfa30ee176ab653e89f40
            })}`);
            if (response.status < 200 || response.status >= 400)
                throw new Error(`${response.statusText}`);
            const tokens = yield fetchTokens(chainId);
            const j = yield response.json();
            const srcUsd = (0, web3_candies_1.bn)(((_a = tokens[(0, web3_candies_1.web3)().utils.toChecksumAddress(src.address)]) === null || _a === void 0 ? void 0 : _a.usd) || 0);
            const dstUsd = (0, web3_candies_1.bn)(((_b = tokens[(0, web3_candies_1.web3)().utils.toChecksumAddress(dst.address)]) === null || _b === void 0 ? void 0 : _b.usd) || 0);
            const dstAmount = (0, web3_candies_1.bn)(j.data.outAmount);
            const data = j.data.data || "0x";
            return {
                dstAmount,
                srcUsd,
                dstUsd,
                data,
                path: [],
            };
        });
    }
    OpenOcean.findRoute = findRoute;
    const tokens = {};
    function fetchTokens(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (lodash_1.default.size(tokens[chainId]))
                return tokens[chainId];
            const response = yield fetch(`${URL}/${chainNames[chainId]}/tokenList`);
            if (response.status < 200 || response.status >= 400)
                throw new Error(`${response.statusText}`);
            const t = (yield response.json()).data;
            const parsed = lodash_1.default.map(t, (token) => ({
                token: {
                    address: (0, web3_candies_1.web3)().utils.toChecksumAddress(token.address),
                    decimals: parseInt(token.decimals),
                    symbol: token.symbol || "",
                    name: token.name || token.symbol || "",
                    logoUrl: token.icon || "",
                },
                usd: parseFloat(token.usd),
            }));
            tokens[chainId] = lodash_1.default.mapKeys(parsed, (t) => t.token.address);
            return tokens[chainId];
        });
    }
})(OpenOcean = exports.OpenOcean || (exports.OpenOcean = {}));
